// TODO: Use global theming instead of hardcoding pixel values
import makeStyles from '@mui/styles/makeStyles';

export default makeStyles({
  expand: {
    height: '32px',
    color: '#FFCD11', // How? How? How do I get theme.pallette.secondary.main?
  },
  title: {
    display: 'flex',
    alignItems: 'center',
  },
  userMenu: {
    cursor: 'pointer',
  },
  link: {
    textDecoration: 'none',
    color: '#505568',
  },
});
